import { withTranslations } from 'src/i18n/static-generation';
import { PageMetas } from 'src/types/meta';
import LocationBasedTermsView from 'src/views/LocationBasedTerms';
export const getStaticProps = withTranslations<PageMetas>(() => ({
  props: {
    noindex: true,
    isIncidental: true
  }
}));
export default LocationBasedTermsView;